var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.556 17A3.778 3.778 0 1 0 0 17a3.778 3.778 0 0 0 7.556 0ZM20.778 17a3.778 3.778 0 1 0-7.555 0 3.778 3.778 0 0 0 7.555 0ZM34 17a3.778 3.778 0 1 0-7.556 0A3.778 3.778 0 0 0 34 17Z",
    fill: "#4F4F4F"
  })));
};
export default SvgMenu;